
import {Vue, Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator';
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import TcKimlikNumarasi from "@/components/inputs/TcKimlikNumarasi.vue";
import YabanciKimlikNumarasi from "@/components/inputs/YabanciKimlikNumarasi.vue";
import {KisiSorgulaCevap} from "@/plugins/uyap-plugin/uyap/KisiSorgula";
import {AdresTuru} from "@/enum/AdresTuru";
import {AdresEntity} from "@/entity/AdresEntity";
import Dates from "@/components/inputs/Dates.vue";
import CinsiyetPicker from "@/components/pickers/CinsiyetPicker.vue";
import YabanciUyrukSehirInput from "@/components/inputs/YabanciUyrukSehirInput.vue";
import SehirPicker from "@/components/pickers/SehirPicker.vue";
import TarafSifatiPicker from "@/components/pickers/TarafSifatiPicker.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import VergiNumarasi from "@/components/inputs/VergiNumarasi.vue";
import SirketTipiPicker from "@/components/pickers/SirketTipiPicker.vue";
import VergiNumarasiKurumForm from "@/components/inputs/VergiNumarasiKurumForm.vue";
import {SirketTipi} from "@/enum/SirketTipi";
import {KurumSorgulamaCevap, KurumSorgulamaTalep} from "@/plugins/uyap-plugin/uyap/KurumSorgulama";
import {HarcDonemiEntity} from "@/entity/HarcDonemiEntity";

@Component({
  components: {
    VergiNumarasiKurumForm, SirketTipiPicker, VergiNumarasi,
    Tutar, TarafSifatiPicker,
    SehirPicker,
    YabanciUyrukSehirInput,
    CinsiyetPicker,
    Dates,
    YabanciKimlikNumarasi, TcKimlikNumarasi, FormWrapper}
})
export default class NewBorcluEditForm  extends Mixins(ObjectInputMixin) {
  @Prop() hideButton!: any;
  @Prop({default:true}) borclu_mu!: boolean;
  @Ref('formWrapper') formWrapper!: FormWrapper;
  sirketTipi = SirketTipi;
  harcSecim:boolean=false
  secilenler:Array<HarcDonemiEntity> = [];
  items:Array<any> = [];
  uyapSorgusuYapildi: boolean = false;

  mounted(){
    this.laodHarcList()
  }

  @Watch('localValue.harc_muaf_mi')
  changeHarcMuaf(){
    if (this.localValue.harc_muaf_mi){
      this.harcSecim = true
    }else{
      this.harcSecim = false
    }
  }

  enterHarclar(){
    this.localValue.secilen_harclar = this.secilenler
  }

  laodHarcList(){
    if (!this.localValue.tc_kimlik_no){
      this.$http.get("/api/v1/harc-donemi").then((response) => {
        const lastItem = response.data.length - 1;
        this.items = response.data[lastItem].harclar;
      });
    }

  }

  save(){
    this.formWrapper.onFly = true;
    if (this.borclu_mu){
      this.$http
          .put('/api/v1/borclu/' + parseInt(this.$route.params.id) + '/bilgisi',this.localValue)
          .then(() => {
            this.formWrapper.onFly = false;
          }).then(()=>{
        this.$emit('onSuccess');
      });
    }else{
      if (this.localValue.tc_kimlik_no || this.localValue.yabanci_uyruklu_mu){
        this.$http
            .put('/api/v1/kisi/' + this.localValue.id, this.localValue)
            .then(() => {
              this.formWrapper.onFly = false;
            }).then(()=>{
          this.$emit('onSuccess');
        });
      }else{
        this.$http
            .put('/api/v1/kurum/' + this.localValue.kurum_id, this.localValue)
            .then(() => {
              this.formWrapper.onFly = false;
            }).then(()=>{
          this.$emit('onSuccess');
        });
      }
    }
  }
  async onTcKimlikNoChange() {
    if (this.localValue.tc_kimlik_no.length == 11) {
      await this.$http.get('/api/v1/kisi/filter?keyword=' + this.localValue.tc_kimlik_no).then((response) => {
        if (response.data.length > 0)
          this.localValue = response.data[0];
        this.input();
        this.$emit('vekiller')
      });
    } else
      this.input();
  }

  get sirketAdiRule() {
    if (this.localValue.sirket_adi) {
      if (this.localValue.sirket_adi.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return 'Lütfen bu alanı doldurun.';
  }

  onVergiNumarasiChange() {
    if (this.localValue.vergi_no.length == 10 || this.localValue.vergi_no.length == 11) {
      this.$http.get('/api/v1/kurum/filter?keyword=' + this.localValue.vergi_no).then((response) => {
        if (response.data.length > 0)
          this.localValue = response.data[0];
        this.input();
      });
    } else
      this.input();
  }


  uyapSorgu(sorgu: KisiSorgulaCevap) {
    this.uyapSorgusuYapildi = true;
    this.localValue.ad = sorgu.adi
    this.localValue.soyad = sorgu.soyadi
    this.localValue.cinsiyet = sorgu.cinsiyeti == "E" ? 'erkek' : 'kadin';
    if (sorgu.dogumTarihiStr && sorgu.dogumTarihiStr.trim() !== '') {
      try {
        let date = sorgu.dogumTarihiStr.split("/").reverse().join("-");
        this.localValue.dogum_tarihi = date;
      } catch (e) {
        this.localValue.dogum_tarihi = null;
      }
    } else {
      this.localValue.dogum_tarihi = null;
    }
    if (sorgu.aktifMernisAdresiSorgusu && !this.localValue.adresler.find((adres:any) => (adres.adres_tur_id == AdresTuru.mernis))) {
      let mernis = new AdresEntity();
      mernis.adres_tur_id = AdresTuru.mernis;
      this.localValue.adresler.push(mernis);
    }
    this.input();
  }

  uyapSorguKurum(sorgu: Array<KurumSorgulamaCevap>) {
    // TODO: Array olarak mı gelecek tespit edilmeli
    console.log('sorgu--->',sorgu)
    this.localValue.sirket_adi = sorgu[0].kurumAdi;
    this.localValue.vergi_no = sorgu[0].vergiNo;
    this.localValue.ticaret_sicil_no = sorgu[0].ticaretSicilNo;
    this.input();
  }

  async sorgulaKurum(data: KurumSorgulamaTalep) {
    let cevap:any = await this.$uyap.KurumSorgulama().run(data);
    this.uyapSorgu(cevap);
  }

  get yasKontrol() {
    if (this.localValue.dogum_tarihi) {
      return this.$helper.yasOgren(this.localValue.dogum_tarihi) < 18;
    } else
      return false
  }

  get yasRule() {
    if (this.uyapSorgusuYapildi && !this.localValue.dogum_tarihi) {
      return true;
    }
    if (this.localValue.dogum_tarihi) {
      let todayGetTime = new Date(new Date().toISOString().slice(0, 10)).getTime();
      let dogumTarihiGetTime = new Date(this.localValue.dogum_tarihi).getTime();
      if (todayGetTime - dogumTarihiGetTime >= 0)
        return true;
      else
        return 'Doğum tarihi gelecek bir tarih olamaz.';
    } else
      return true;
  }

  get adRule() {
    if (this.localValue.ad) {
      if (this.localValue.ad.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return 'Lütfen bu alanı doldurun.';
  }

  get soyadRule() {
    if (this.localValue.soyad) {
      if (this.localValue.soyad.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return 'Lütfen bu alanı doldurun.';
  }

  get isHideButton() {
    return this.hideButton || this.hideButton === "";
  }
}
